import angular from 'angular';
import controller from './fileCurrent.controller';
import template from './fileCurrent.html';
import './fileCurrent.scss';
import FileCurrentComponent from './fileCurrent.component';

const fileCurrentConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('fileCurrent', {
		title:                  'File (current)',
		template,
		group:                  'advanced',
		children:               false,
		selectable:             true,
		settings:               new FileCurrentComponent(),
		icon:                   'fa fa-file',
		views:                  [
			{
				name:     'Display',
				template: 'kform/components/fileCurrent/display.html',
			},
			{
				name:     'API',
				template: 'kform/components/fileCurrent/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
		controller,
	});
};

export default angular.module('app').config(fileCurrentConfig);
